"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
var _utils = require("../utils");
var _popup = require("../mixins/popup");
var _loading = _interopRequireDefault(require("../loading"));
var _icon = _interopRequireDefault(require("../icon"));
/* eslint-disable max-len */

var _use = (0, _utils.use)('toast'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  mixins: [_popup.PopupMixin],
  props: {
    className: null,
    forbidClick: Boolean,
    message: [String, Number],
    iconName: String,
    iconSize: String,
    type: {
      type: String,
      default: 'text'
    },
    loadingType: {
      type: String,
      default: 'circular'
    },
    lockScroll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    clickable: function clickable() {
      return !(this.value && this.forbidClick);
    }
  },
  watch: {
    clickable: function clickable() {
      this.toggleClickable();
    }
  },
  mounted: function mounted() {
    this.toggleClickable();
  },
  beforeDestroy: function beforeDestroy() {
    this.toggleClickable();
  },
  methods: {
    toggleClickable: function toggleClickable() {
      var action = this.clickable ? 'remove' : 'add';
      document.body.classList[action]('z-toast--unclickable');
    }
  },
  render: function render(h) {
    var _this = this;
    var type = this.type,
      message = this.message,
      iconName = this.iconName,
      iconSize = this.iconSize;
    var Content = function Content() {
      var size = iconSize || '60px';
      if (type === 'loading') {
        size = iconSize || '48px';
      }
      var name = type;
      // 新图标
      // todo: 转至icon组件 toast-${type}
      if (type === 'warn') name = 'https://dl.zhuanstatic.com/fecommon/warn.svg';
      if (type === 'success') name = 'https://dl.zhuanstatic.com/fecommon/success.svg';
      if (type === 'network') name = 'https://dl.zhuanstatic.com/fecommon/network.svg';
      if (type === 'fail') name = 'https://dl.zhuanstatic.com/fecommon/fail.svg';
      switch (type) {
        case 'text':
          return h("div", [message]);
        case 'html':
          return h("div", {
            "domProps": {
              "innerHTML": message
            }
          });
        case 'loading':
          return [h(_loading.default, {
            "attrs": {
              "size": size,
              "color": "white",
              "type": _this.loadingType
            }
          }), (0, _utils.isDef)(message) && h("div", {
            "class": bem('text')
          }, [message])];
        case 'success':
        case 'fail':
        case 'network':
        case 'warn':
          return [h(_icon.default, {
            "attrs": {
              "size": size,
              "color": "white",
              "name": "" + (iconName || name),
              "classPrefix": "zziconfont"
            },
            "class": bem('icon')
          }), (0, _utils.isDef)(message) && h("div", {
            "class": bem('text')
          }, [message])];
        default:
          return [h(_icon.default, {
            "attrs": {
              "size": size,
              "color": "white",
              "name": type
            },
            "class": bem('icon')
          }), (0, _utils.isDef)(message) && h("div", {
            "class": bem('text')
          }, [message])];
      }
    };
    return h("transition", {
      "attrs": {
        "name": "z-fade"
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "class": [bem([type]), this.className]
    }, [Content()])]);
  }
});
exports.default = _default;